// French YouTube trailer per title, when an official French-language upload was
// found (86/90 — the 4 missing are unreleased 2026 titles with no French promo yet).
// Applied over the English trailer (info.ts, INFO[id].yt) when the UI language is FR.
export const TRAILER_FR: Record<string, string> = {
  cap1: 'https://www.youtube.com/watch?v=hgS9vkXtas0',
  capmarvel: 'https://www.youtube.com/watch?v=rndLWLmwgeA',
  ironman1: 'https://www.youtube.com/watch?v=rDCTb9Gp2qk',
  ironman2: 'https://www.youtube.com/watch?v=SQnuLDnhB7g',
  hulk: 'https://www.youtube.com/watch?v=6z8Nmm5LX4c',
  thor1: 'https://www.youtube.com/watch?v=pzT3yeV9lT4',
  avengers1: 'https://www.youtube.com/watch?v=b-kTeJhHOhc',
  thor2: 'https://www.youtube.com/watch?v=JXmOod9zBME',
  ironman3: 'https://www.youtube.com/watch?v=wnEr73Rq3Ac',
  cap2: 'https://www.youtube.com/watch?v=6mQWmUwxZjI',
  gotg1: 'https://www.youtube.com/watch?v=HbB1LC_QyK0',
  gotg2: 'https://www.youtube.com/watch?v=qe6EjVKba9Q',
  avengers2: 'https://www.youtube.com/watch?v=CjPh8dyUdC8',
  dd_s1: 'https://www.youtube.com/watch?v=-g8fSUNeYIE',
  jj_s1: 'https://www.youtube.com/watch?v=gO2QqWyBTas',
  antman1: 'https://www.youtube.com/watch?v=_mWjqYXA59E',
  cap3: 'https://www.youtube.com/watch?v=fuIIGDjEj8Q',
  dd_s2: 'https://www.youtube.com/watch?v=RB1C1DW8k0I',
  lc_s1: 'https://www.youtube.com/watch?v=Yq5vJYBEw54',
  blackwidow: 'https://www.youtube.com/watch?v=5XXPCHLzbTU',
  blackpanther1: 'https://www.youtube.com/watch?v=lyKngqfmqW4',
  spiderman1: 'https://www.youtube.com/watch?v=Y8ErdqD5YPc',
  drstrange1: 'https://www.youtube.com/watch?v=JaRIhAyNkrY',
  thor3: 'https://www.youtube.com/watch?v=sd_67Nql34k',
  if_s1: 'https://www.youtube.com/watch?v=tNkoUqhCpt8',
  defenders: 'https://www.youtube.com/watch?v=jNjxGT7NkYE',
  pun_s1: 'https://www.youtube.com/watch?v=bwRv7RnmRHM',
  avengers3: 'https://www.youtube.com/watch?v=eIWs2IUr3Vs',
  jj_s2: 'https://www.youtube.com/watch?v=lJeEd-l9w1w',
  lc_s2: 'https://www.youtube.com/watch?v=ToJ_9WCrOAg',
  if_s2: 'https://www.youtube.com/watch?v=6Hg52Pa-JkA',
  dd_s3: 'https://www.youtube.com/watch?v=25XXlWbN9A4',
  antman2: 'https://www.youtube.com/watch?v=5IJxUX75p_w',
  pun_s2: 'https://www.youtube.com/watch?v=XRLmxwpSN9s',
  jj_s3: 'https://www.youtube.com/watch?v=r_6hTOMBXQo',
  avengers4: 'https://www.youtube.com/watch?v=wV-Q0o2OQjQ',
  wandavision: 'https://www.youtube.com/watch?v=bQCvUqWqivY',
  falcon: 'https://www.youtube.com/watch?v=l3VMNZH61UU',
  loki1: 'https://www.youtube.com/watch?v=iYpS70gCsvw',
  whatif1: 'https://www.youtube.com/watch?v=NDfaxdYx34Y',
  farfromhome: 'https://www.youtube.com/watch?v=SFoCPkEfHEM',
  hawkeye: 'https://www.youtube.com/watch?v=P-6jVdKj_dk',
  moonknight: 'https://www.youtube.com/watch?v=BxcyFgJSpjQ',
  shangchi: 'https://www.youtube.com/watch?v=PD3rUCBFDlI',
  eternals: 'https://www.youtube.com/watch?v=nHcubNwuKFA',
  msmarvel: 'https://www.youtube.com/watch?v=JTb4NIzxtYE',
  nowayhome: 'https://www.youtube.com/watch?v=KR-eyxSuOgk',
  drstrange2: 'https://www.youtube.com/watch?v=J7u1bDo_4sk',
  thor4: 'https://www.youtube.com/watch?v=wyxbc_wQjaI',
  shehulk: 'https://www.youtube.com/watch?v=YSbqVNImGS0',
  wakandaforever: 'https://www.youtube.com/watch?v=DlGIWM_e9vg',
  secretinvasion: 'https://www.youtube.com/watch?v=F8nKPJ-JPac',
  loki2: 'https://www.youtube.com/watch?v=3zXE2MtUSUc',
  whatif2: 'https://www.youtube.com/watch?v=5Xy95FAyMVM',
  quantumania: 'https://www.youtube.com/watch?v=Q0uaHT1wsTQ',
  gotg3: 'https://www.youtube.com/watch?v=WxA-eZ72FsQ',
  marvels: 'https://www.youtube.com/watch?v=9z9_bfhpLzU',
  echo: 'https://www.youtube.com/watch?v=aZtwmbk1HkA',
  'xmen97-1': 'https://www.youtube.com/watch?v=EBdJ06mVPmM',
  xmen1: 'https://www.youtube.com/watch?v=QLtF7ZmXfjw',
  x2: 'https://www.youtube.com/watch?v=UfbTJ1Mgxdg',
  xlaststand: 'https://www.youtube.com/watch?v=KMZ1FWENm3w',
  xorigins: 'https://www.youtube.com/watch?v=ZmPlmK7vaEY',
  xfirstclass: 'https://www.youtube.com/watch?v=XzO78txLmBc',
  thewolverine: 'https://www.youtube.com/watch?v=WKrknCZIj2Q',
  xdofp: 'https://www.youtube.com/watch?v=oozLmcK-Vis',
  dp1: 'https://www.youtube.com/watch?v=tgzKrpDE4qM',
  xapocalypse: 'https://www.youtube.com/watch?v=YYpr8RubbyE',
  logan: 'https://www.youtube.com/watch?v=maJ6yBe0Lkc',
  dp2: 'https://www.youtube.com/watch?v=mkomQpUgMLU',
  darkphoenix: 'https://www.youtube.com/watch?v=jyTgXu5bZf4',
  newmutants: 'https://www.youtube.com/watch?v=6ZdL4M7JRCY',
  deadpoolwolverine: 'https://www.youtube.com/watch?v=2t9-VpzzNmY',
  agatha: 'https://www.youtube.com/watch?v=cDdg3njmV3E',
  whatif3: 'https://www.youtube.com/watch?v=_oRJFwPC_gE',
  yfns1: 'https://www.youtube.com/watch?v=llWZG7GwzZw',
  bravenewworld: 'https://www.youtube.com/watch?v=Hh9fV_5iP2Q',
  daredevil1: 'https://www.youtube.com/watch?v=DF4h9waAccc',
  thunderbolts: 'https://www.youtube.com/watch?v=cYHyGlHIOOY',
  ironheart: 'https://www.youtube.com/watch?v=wJqMZEIcvx4',
  fantasticfour: 'https://www.youtube.com/watch?v=sdPlkUZE98I',
  eyesofwakanda: 'https://www.youtube.com/watch?v=3ch9VVrLqG0',
  marvelzombies: 'https://www.youtube.com/watch?v=Txa-LEY8i3E',
  wonderman: 'https://www.youtube.com/watch?v=amvG2BUfEGU',
  daredevil2: 'https://www.youtube.com/watch?v=TzKZsEHiCHU',
  'xmen97-2': 'https://www.youtube.com/watch?v=Iq301MdVaYg',
  doomsday: 'https://www.youtube.com/watch?v=g9NAGSPpfjs',
};
